<div class="page-layout blank p-24" fusePerfectScrollbar>
	<dataset-list
		[showTitle]='true'
		[elevate]='false'
		[datasetCode]='"passport"'
		[enableCreate]='true'
		[autoFetchData]='false'
	></dataset-list>
</div>